import { createContractRequest } from './helper';
export const postOfferWubReport = createContractRequest({
    route: '/contract/offers/wubReport',
    method: 'post',
    source: 'data',
});
